import { BaseContext } from "src/com/sixdee/crbtportal/utils/basecontext";
import { GridPaginationListViewModelImpl } from "../../../toolkit/grid/gridpagination/gridpaginationlistviewmodel";
import { FlashMessageCardCSSStyle, FlashMessageCardCSSStyleImpl } from "./flashmessagecard/flashmessagecardcss";
import * as React from "react";
import { FlashMessageDto } from "src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto";
import { FlashMessageEvenCardCSSStyle, FlashMessageEvenCardCSSStyleImpl } from "./flashmessagecard/flashmessageevencardcss";
import { DefaultFlashCardComponent } from "./defaultflashcard/defaultflashcardcomponent";


export class FlashMessageDefaultListViewModelImpl extends GridPaginationListViewModelImpl<FlashMessageDto>
{
    protected toneOddCardCSSStyle: FlashMessageCardCSSStyle;
    protected toneEvenCardCSSStyle : FlashMessageEvenCardCSSStyle;
 
    constructor(offset: string, context: BaseContext,title: string, private onCreateClick: any)
    {
        super(offset,context);
        this.toneOddCardCSSStyle = new FlashMessageCardCSSStyleImpl(context);

        this.toneEvenCardCSSStyle = new FlashMessageEvenCardCSSStyleImpl(context);
    }

    getView(t: FlashMessageDto, position: number): boolean | JSX.Element 
    {   
        return <DefaultFlashCardComponent context={this.getContext()} onCreateClick={this.onCreateClick} />;
        
    }
 
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/flashmessagedefaultlistviewmodel.tsx